import { ShieldCheck, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";

export const Trust = () => (
    <section data-testid="trust-section" className="bg-white py-20">
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <Reveal>
                    <div
                        data-testid="trust-item-testing"
                        className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-[#F8FAFC] p-6"
                    >
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#2563EB]/10">
                            <ShieldCheck className="h-5 w-5 text-[#2563EB]" />
                        </span>
                        <p className="text-sm font-medium text-[#0B1F44]">
                            Currently being tested with UK service businesses.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.08}>
                    <div
                        data-testid="trust-item-outcomes"
                        className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-[#F8FAFC] p-6"
                    >
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#2563EB]/10">
                            <TrendingUp className="h-5 w-5 text-[#2563EB]" />
                        </span>
                        <p className="text-sm font-medium text-[#0B1F44]">
                            Built around measurable commercial outcomes.
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
